import { Socket } from "socket.io-client";
import { ModalityDataSource } from "../Types/ModalityDataSource";
import { ImagePage } from "./ImagePage";
import { PersystImagePageProperties } from "./PersystPageManager";


type PersystEEGPageProperties = PersystImagePageProperties & {
	LFF: number
	HFF: number
	notch: number
	sensitivityMicrovolts: number
	isArtifactReductionEnabled: boolean
}

export class PersystEEGImagePage extends ImagePage<PersystEEGPageProperties> {
	public recordingStartTime: number = 0
	public LFF: number = 1
	public HFF: number = 30
	public notch: number = 60
	public sensitivityMicrovolts: number = 10
	public isArtifactReductionEnabled: boolean = true

    socketEventName = () => "render_persyst_eeg"

	getRenderSettings = () => ({
		height: this.height,
		width: this.width,
		LFF: this.LFF,
		HFF: this.HFF,
		notch: this.notch,
		sensitivityMicrovolts: this.sensitivityMicrovolts,
		isArtifactReductionEnabled: this.isArtifactReductionEnabled,
	})

    requestData(batch: Map<number, ModalityDataSource[]>, socket: Socket): void {
		if (this.getDataQuerySocket === null) {
			return
		}

		let relativeStartTimeSeconds = Math.round(Math.max(0, this.startTime - this.recordingStartTime) / 1000)

		if (this.recordingStartTime === 0) {
			relativeStartTimeSeconds = 0
		} 

		batch.forEach((modalities, dataObjectId) => {
			socket.emit(
				this.socketEventName(), 
				this.patientId, 
				dataObjectId, 
				this.id,
				modalities[0],
				this.sensitivityMicrovolts,
				this.notch,
				this.HFF,
				this.LFF,
				this.isArtifactReductionEnabled,
				this.startTime,
				this.endTime,
				this.width,
				this.height,
				relativeStartTimeSeconds,
				this.getSettingsHash()
			)
		})
    }
}